"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tag_1 = require("../operators/tag");
function tag(tag) {
    return tag_1.tag(tag)(this);
}
exports.tag = tag;



//////////////////
// WEBPACK FOOTER
// /app/node_modules/rxjs-spy/operator/tag.js
// module id = K4NU
// module chunks = 18